import NotificationsNoneOutlined from '@mui/icons-material/NotificationsNoneOutlined';
import NotificationsOffOutlined from '@mui/icons-material/NotificationsOffOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import useMuteToggle from '~components/Messaging/useMuteToggle';
import { MessagingChannel } from '~hooks/useMessaging/models';

// Matches the small icon the button shows, so the row does not jump while it saves.
const SAVING_SPINNER_SIZE_IN_PX = 20;

type MessagingMuteToggleProps = {
  channel: MessagingChannel;
};

export default function MessagingMuteToggle({ channel }: MessagingMuteToggleProps) {
  const { isSaving, label, toggleMuted } = useMuteToggle(channel);

  const renderIcon = () => {
    if (isSaving) return <CircularProgress size={SAVING_SPINNER_SIZE_IN_PX} />;
    if (channel.muted) return <NotificationsOffOutlined fontSize="small" />;

    return <NotificationsNoneOutlined fontSize="small" />;
  };

  return (
    <Tooltip title={label}>
      <span>
        <IconButton
          aria-label={label}
          aria-pressed={channel.muted}
          data-test-id="messaging-mute-toggle"
          disabled={isSaving}
          onClick={() => void toggleMuted()}
          size="small"
        >
          {renderIcon()}
        </IconButton>
      </span>
    </Tooltip>
  );
}
